<div class="news-card-gnu">
  <a [routerLink]="[link]">
      <span class="news-card-img">
        <img [src]="image" alt="Título imagem">
      </span>
      <div class="news-card-info">
        <span class="news-card-date">{{date}}</span>
        <h3>{{title}}</h3>

          <span class="news-card-icon">
            <nb-icon icon="eye"></nb-icon>
          </span>

      </div>
    </a>
</div>
